import React from 'react';
import AdminDocument from '../../features/legal/AdminDocument';
export default function AboutAdmin() {
  return <AdminDocument type="about" />;
}
